import { PrimaryButton } from 'sharedComponents/Buttons';
import { Theme, useTheme } from '@mui/material';
import { handleOpenConnectMatchQuiz } from 'features/Connect/utils/connectUtils';
import { ConnectMatchQuizNavBarAccessButtonDataTestIds } from 'data-testids/ConnectDataTestIds';
import auth from 'utils/auth';
import { useStateParam } from 'features/Connect/features/Context/ConnectStateCodeContextProvider';

export const MatchQuizButton: React.FC = () => {
  const jobboardState = useStateParam();
  const user = auth.getUser();
  const userLocation = user?.preference?.geocoded_location;
  const theme = useTheme();

  return (
    <PrimaryButton
      dataTestId={ConnectMatchQuizNavBarAccessButtonDataTestIds.BUTTON}
      onClick={() => handleOpenConnectMatchQuiz(user.id, jobboardState, userLocation)}
      size="extraLarge"
      sx={MATCH_QUIZ_BUTTON_STYLES(theme)}
    >
      Take Your Match Quiz!
    </PrimaryButton>
  );
};

const MATCH_QUIZ_BUTTON_STYLES = (theme: Theme) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
  background: `linear-gradient(90deg, ${theme.palette.info.dark} 0%, ${theme.palette.purple.dark} 100%)`,
  border: `1px solid ${theme.palette.info.dark}`,
  borderRadius: theme.shape.borderRadius * 0.5,
  fontStyle: 'normal',
  lineHeight: '20px',
  height: 42,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 28px',
  boxShadow: 'none',
});
